import { MapPin, Navigation, Phone, Clock } from 'lucide-react';
import { companyInfo } from '../../data/mock';
import { useInView } from '../../hooks/useInView';
import { Button } from '../ui/button';

export const MapSection = () => {
  const [ref, isInView] = useInView();

  return (
    <section id="location" className="py-20 lg:py-28 bg-white" ref={ref}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className={`text-center mb-12 ${isInView ? 'animate-fade-in-up' : 'opacity-0'}`}>
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="section-divider" />
            <span className="text-sm font-semibold text-ind-red-600 uppercase tracking-wider">Our Location</span>
            <div className="section-divider" />
          </div>
          <h2 className="font-heading font-extrabold text-navy-950 text-3xl lg:text-4xl mb-3">
            Visit Our Factory
          </h2>
          <p className="text-navy-500 text-base max-w-2xl mx-auto">
            Located in the heart of Ghaziabad's industrial area, easily accessible for factory visits and bulk order pickups.
          </p>
        </div>

        <div className={`grid grid-cols-1 lg:grid-cols-3 gap-8 ${isInView ? 'animate-fade-in-up' : 'opacity-0'}`} style={{ animationDelay: '0.2s' }}>
          {/* Map */}
          <div className="lg:col-span-2 rounded-2xl overflow-hidden border border-navy-100 shadow-lg h-[400px] bg-navy-50">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3501.5!2d77.4356!3d28.6692!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cf1bb24e5a6a9%3A0x5ce90f4d6e8e1a84!2sIndustrial%20Area%2C%20Ghaziabad%2C%20Uttar%20Pradesh!5e0!3m2!1sen!2sin!4v1707900000000!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="V.R. Enterprises Location"
            />
          </div>

          {/* Contact Info Card */}
          <div className="bg-navy-950 rounded-2xl p-6 lg:p-8 relative overflow-hidden">
            <div className="absolute inset-0 grid-pattern opacity-40" />
            <div className="relative space-y-6">
              <div>
                <h3 className="font-heading font-bold text-white text-xl mb-1">V.R. Enterprises</h3>
                <p className="text-ind-red-400 text-sm font-medium">Manufacturing Unit</p>
              </div>

              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-lg bg-ind-red-600/10 border border-ind-red-600/20 flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-5 h-5 text-ind-red-400" />
                  </div>
                  <div>
                    <p className="text-navy-400 text-xs uppercase tracking-wider mb-1">Address</p>
                    <p className="text-white text-sm leading-relaxed">{companyInfo.address.full}</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-lg bg-ind-red-600/10 border border-ind-red-600/20 flex items-center justify-center flex-shrink-0">
                    <Phone className="w-5 h-5 text-ind-red-400" />
                  </div>
                  <div>
                    <p className="text-navy-400 text-xs uppercase tracking-wider mb-1">Phone</p>
                    <a href={`tel:${companyInfo.phones[0]}`} className="text-white text-sm hover:text-ind-red-400 block">
                      {companyInfo.phones[0]}
                    </a>
                    <a href={`tel:${companyInfo.phones[1]}`} className="text-navy-300 text-sm hover:text-ind-red-400 block">
                      {companyInfo.phones[1]}
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-lg bg-ind-red-600/10 border border-ind-red-600/20 flex items-center justify-center flex-shrink-0">
                    <Clock className="w-5 h-5 text-ind-red-400" />
                  </div>
                  <div>
                    <p className="text-navy-400 text-xs uppercase tracking-wider mb-1">Working Hours</p>
                    <p className="text-white text-sm">Mon - Sat: 9:00 AM - 6:00 PM</p>
                    <p className="text-navy-400 text-sm">Sunday: Closed</p>
                  </div>
                </div>
              </div>

              <a
                href={companyInfo.mapLink}
                target="_blank"
                rel="noopener noreferrer"
                className="block"
              >
                <Button className="w-full bg-ind-red-600 hover:bg-ind-red-700 text-white font-semibold h-11 rounded-lg shadow-lg shadow-ind-red-600/25">
                  <Navigation className="w-4 h-4 mr-2" />
                  Get Directions
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
